export const DURATION = 'Varighed';
export const LESSONS_OF_45_MINUTES = 'Lektioner a 45 min.';
export const ADD_DURATION = 'Tilføj varighed...';
export const ADD_LESSONS_OF_45_MINUTES = 'Tilføj ca. antal lektioner a 45 min...';